import { isCurrentView } from "../../../shared/utils/view-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.payment_needs")) {
    return;
  }

  const form = "payment_needs_form";
  const submitButton = document.getElementById("submit-button");
  const inPerson = document.getElementById(`${form}_in_person`);
  const onlinePerson = document.getElementById(`${form}_online`);
  const remotePerson = document.getElementById(`${form}_remote`);

  enableSubmit();

  inPerson.addEventListener("change", enableSubmit);
  onlinePerson.addEventListener("change", enableSubmit);
  remotePerson.addEventListener("change", enableSubmit);

  function enableSubmit() {
    submitButton.disabled = !(
      inPerson.checked ||
      onlinePerson.checked ||
      remotePerson.checked
    );
  }
});
